"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  MOST_DOWNLOADED: 'MOST_DOWNLOADED',
  RECENTLY_ADDED: 'RECENTLY_ADDED',
  PRICE_LOW_TO_HIGH: 'PRICE_LOW_TO_HIGH',
  PRICE_HIGH_TO_LOW: 'PRICE_HIGH_TO_LOW'
};
exports.default = _default;
module.exports = exports.default;